export default __webpack_public_path__ + "static/media/logout.d7abff4c.svg";